module.exports = __webpack_public_path__ + "b-lite-2-before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/novinky/b-lite-2-before.jpg
// module id = 1855
// module chunks = 0